document.addEventListener(":productRecommendations", function(event) {
  //   ===============you may also like===============
  if(!$('.set_best_seller').hasClass('slick-initialized')) {
    $('body .set_best_seller').slick({
      dots:false,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
      ]
    });
  }

  bestSellerSlider();

});
// Start window custom event
window.addEventListener("globoFilterRenderCompleted",function(e){ 
  $('.background-slideshow').css('opacity','0');
  $('.background-slideshow').css('height','100px');

  $('.background-slideshow').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'> <i class='fa fa-angle-left'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'> <i class='fa fa-angle-right'></i></i></button>",
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    } 
    ]
  }); 

  $('.background-slideshow img').bind("click", function(){
    var src= $(this).attr('src');
    var href= $(this).attr('data-href');
    $(this).parents('.spf-product-card').find('.spf-product-card__image-wrapper').attr('href',href);
    $(this).parents('.spf-product-card').find('.spf-product-card__image').attr('src',src);
  });

  $('.background-slideshow').css('height','unset');
  $('.background-slideshow').css('opacity','1');
   
  $('.mobile_sldier_slideshow').slick({ 
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'> <i class='fa fa-angle-left'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'> <i class='fa fa-angle-right'></i></i></button>"
  });

  $('.mobile_sldier_slideshow img').bind("click", function(){
    var src= $(this).attr('src');
    var href= $(this).attr('data-href');
    $(this).parents('.spf-product-card').find('.spf-product-card__image-wrapper').attr('href',href);
    $(this).parents('.spf-product-card').find('.spf-product-card__image').attr('src',src);
  });

});
 // Start window custom event


function bestSellerSlider() {
  $('.thumbanils').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'> <i class='fa fa-angle-left'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'> <i class='fa fa-angle-right'></i></i></button>",
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true
      }
    } 
		]
	});

  $('.thumbanils img').click(function(){
    var src = $(this).attr('src');
    // on the home page
    $(this).parents('.product').find('.main-image').attr('src',src);
    // on the product page
    $(this).closest('div[sa-swatch-root]').find('.product__img').attr('srcset',src);
    $(this).closest('div[sa-swatch-root]').find('.product__img').attr('data-srcset',src);
  });
}

 document.addEventListener('DOMContentLoaded', () => {
  $('body').removeClass('overhidden');

  var controls = document.querySelectorAll('#announcement-slider .controls');
	for(var i=0; i<controls.length; i++){
		controls[i].style.display = 'inline-block';
	}

	var slides = document.querySelectorAll('#announcement-slider .item');
	var currentSlide = 0;
	var slideInterval = setInterval(nextSlide,5000);

	function nextSlide(){ goToSlide(currentSlide+1); }

	function previousSlide(){ goToSlide(currentSlide-1); }

	function goToSlide(n){
		slides[currentSlide].className = 'item';
		currentSlide = (currentSlide+1)%slides.length;
		slides[currentSlide].className = 'item showing';
	}

	function pauseSlideshow(){ clearInterval(slideInterval); }

	function playSlideshow(){ slideInterval = setInterval(nextSlide,2000); }

	var announce_next = document.getElementById('announce_next');
	var announce_previous = document.getElementById('announce_previous');

	announce_next.onclick = function(){ pauseSlideshow(); nextSlide(); };
	announce_previous.onclick = function(){ pauseSlideshow(); previousSlide(); };

  $('.background-slideshow').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
      arrows:true,
      prevArrow:"<button type='button' class='slick-prev pull-left'> <i class='fa fa-angle-left'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'> <i class='fa fa-angle-right'></i></i></button>",
        responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      } 
    ]
      
  }); 

  $('.cart_page_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
      prevArrow:"<button type='button' class='cart_page_prev slick-prev pull-left'><div class='inner_icons'><img class='normal_icon' src='https://cdn.shopify.com/s/files/1/0333/0936/0264/files/arrow_left.jpg'/><img class='hover_icon' src='https://cdn.shopify.com/s/files/1/0333/0936/0264/files/Hover_Varrowprv.png'/></button></div>",
   nextArrow:"<button type='button' class='cart_page_next slick-next pull-right'><div class='inner_icons'><img class='normal_icon' src='https://cdn.shopify.com/s/files/1/0333/0936/0264/files/arrow-right-img.png'/><img class='hover_icon' src='https://cdn.shopify.com/s/files/1/0333/0936/0264/files/Hover_Varrownxt.png'/></button></div>",
    responsive: [
        {
        breakpoint: 482,
        settings: {
          arrows: true,
          slidesToShow: 1
        }
        }
    ]
  });
    
     
  $('.header-announce1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows:true,
    adaptiveHeight: false,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right'></i></button>",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          arrows:true,
        }
      }
    ]
  });
 
  $('.slider-collection').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: 0,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//cdn.shopify.com/s/files/1/0333/0936/0264/files/60552_copy.png?v=1582544220'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='//cdn.shopify.com/s/files/1/0333/0936/0264/files/60552.png?v=1582544220'></button>",
    responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
        slidesToShow: 3,
        centerMode: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 1,
        centerMode: true
      }
    },
    {
    breakpoint: 480,
    settings: {
      dots:true,
      arrows: false,
      slidesToShow: 1
    }
    } 
  ]
  });
  
  
  $('.mobslider-collection').slick({
    dots:true,
    arrows: false,
    slidesToShow: 1
  });
  
  // =========================Tab slider===========================================
  
  $('.tab-content, .tabcontent').slick({
    arrows: true,
    slidesToShow: 4,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//cdn.shopify.com/s/files/1/0333/0936/0264/files/60552_copy.png?v=1582544220'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='//cdn.shopify.com/s/files/1/0333/0936/0264/files/60552.png?v=1582544220'></button>",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 482,
        settings: {
          arrows: false,
          slidesToShow: 2
        }
      }
    ]
  });
  
  
  bestSellerSlider();

  //===================main image change on swatch===================
  $('.coloumn-corporate').slick({
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  });

  $('.instagram-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows:true,
    prevArrow:"<button type='button' class='slick-prev pull-left'> <i class='fa fa-angle-left'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'> <i class='fa fa-angle-right'></i></i></button>",
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    } 
  ]
  });

  $('.custom_review_slider').slick({
		dots: true,
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
	});


	$('.overview_slider').slick({ 
        centerMode: true,
    	centerPadding: '250px',
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,       
     	arrows:false,
//         prevArrow:"<button type='button' class='slick-prev pull-left'> <i class='fa fa-angle-left'></i></button>",
//         nextArrow:"<button type='button' class='slick-next pull-right'> <i class='fa fa-angle-right'></i></i></button>",
		responsive: [
		{
			breakpoint: 1025,
			settings: {
              	centerMode: true,
    			centerPadding: '120px',
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true
// 				dots: true
			}
		},
        {
			breakpoint: 778,
			settings: {
              	centerMode: false,
              	dots: true,
				slidesToShow: 1,
				slidesToScroll: 1
			}
		},  
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
	});


  
  $('.product-single__thumbnails').not('.slick-initialized').slick({
		speed: 300,
		slidesToShow: 7,
		slidesToScroll: 1,
		vertical: true,
		focusOnSelect: true,
		verticalSwiping: true,
		dots: false,
		centerPadding: '100px',
		arrows: true,
		infinite: true,
		prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
		nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
		responsive: [
          {
			breakpoint: 1480,
			settings: {
				slidesToShow: 6,
				slidesToScroll: 1,
				infinite: true,
			}
		},
          {
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
			}
		}, {
			breakpoint: 482,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				verticalSwiping: false,
				vertical: false,
				dots: true
			} 
		}
		]
	});
  console.log('20 seconds load')
      $('.video__sliders').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
      infinite: true,
      centerMode:true,
      dots:false,
        focusOnSelect: true,
        centerPadding: '100px',
        prevArrow:'<button type="button" class="slick-prev pull-left video-slide-left"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" /></svg></button>',
		nextArrow:'<button type="button" class="slick-next pull-right video-slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" /></svg></button>',
      })
//$('.video__sliders').slick('unslick').slick('reinit').slick();


   

  if($('.mini_cs_slider__inner').length > 0) {
    var mini_cs_slider = $('.mini_cs_slider__inner');
    mini_cs_slider.slick({
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
    });
  }

  if ($(window).width() <= 768) {
    $('.slider-massaonry').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    });

    $('.center-watch ul').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: false,
      adaptiveHeight: true
  
    });

    var slickCarousel = $('.grid-link__container');
    slickCarousel.slick({
      dots: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: false,
      arrows: true,
      infinite: true,
      prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
    });

    $('body .slider-recom').slick({
      dots:false,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1
    });  
  }
});




$(document).ready(function(){   

  $('.background-slideshow img').bind("click", function(){
    var src= $(this).attr('src');
    var href= $(this).attr('data-href');
    $(this).parents('.spf-product-card').find('.spf-product-card__image-wrapper').attr('href',href);
    $(this).parents('.spf-product-card').find('.spf-product-card__image').attr('src',src);
  })
  
  $('.add-btn').click(function(){
    var id = $(this).attr('data-id');
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          quantity: 1,
          id: id
      }, 
      dataType: 'json',           
      success: function() { 
      $('.update-cart').trigger('click');
      }
    });
  });
  
  $('body').removeClass('overhidden');
  
  //===================main image change on swatch===================
  $('.swatch-element label').click(function(){
    var dataimage = $(this).attr('data-image');
    $('.product-single__image').attr('src',dataimage);
    $('.product-single__image').attr('data-srcset',dataimage);
    $('.product-single__image').attr('srcset',dataimage);
  });

  //   --------------Swacth select------

  $('.swatch-element').on('click',function(){
    $('.swatch-element').removeClass('swatch-one');
    $(this).addClass('swatch-one');
  });



  $('#tab-wrapper li:first').addClass('active');
      
  $('#tab-body > div').hide();
  $('#tab-body > div:first').show();
  $('#tab-wrapper a').click(function() {
      $('#tab-wrapper li').removeClass('active');
      $(this).parent().addClass('active');
      var activeTab = $(this).attr('href');
      $('#tab-body > div:visible').hide();
      $(activeTab).show();
      return false;
  });
  
  $('.scroll-tabs li:first').addClass('active');
      
  $('.scroll-tabs > div').hide();
  $('.scroll-tabs > div:first').show();
  $('.scroll-tabs a').click(function() {
      $('.scroll-tabs li').removeClass('active');
      $(this).parent().addClass('active');
      var activeTab = $(this).attr('href');
      $('#tab-body > div:visible').hide();
      $(activeTab).show();
      return false;
  });
    
  $('.star-review').each(function(){
    var url = $(this).attr('data-href');
    // console.log(url);
    var element = this;
    $.ajax({
      type:"GET",
      url: url,
      cache: false,
      success: function(data){
        var result = $(data).find('.star-review .jdgm-widget').html();
        var numbers = $(data).find('.star-review .jdgm-prev-badge').attr('data-number-of-reviews');
        console.log(numbers);
        $(element).html(result);
      if(numbers > 0){
                var number = "(" + numbers + ")";
        $(element).siblings(".number").html(number);
              }
      }
    });
  });
 
  $('#tab-wrapper li.active a').trigger('click');

  if($('body').data('template').indexOf('product') > -1) {
    $("#video1, #video2 , #video3").videoPopup({
      // autoplay on open
      autoplay: false,
      // shows video controls
      showControls: true,
      // colors of controls
      controlsColor: null,
      // infinite loop
      loopVideo: false,
      // shows video information
      showVideoInformations: true,
      // width
      width: null
    });
  }

  $menuLeft = $('.pushmenu-left');
  $nav_list = $('.icons-menu');
  
  $nav_list.click(function() {
    $(this).toggleClass('active');
    $('.pushmenu-push').toggleClass('pushmenu-push-toright');
    $menuLeft.toggleClass('pushmenu-open');
  });
  
  $('.overlays').click(function(){
  $('.icons-menu').trigger('click');
  })
  
  $('.price-review').each(function(){
    var url = $(this).attr('data-href');
    //console.log(url);
    var element = this;
    $.ajax({
      type:"GET",
      url: url,
      cache: false,
      success: function(data){
        // console.log(data);
        var result = $(data).find('.metafieldss').html();
        $(element).html(result);
      }
    });
  });

  $('#tabs-titles li').click(function(){
    var text = $(this).text();
    $('.col-md-8.col-sm-8.col-xs-12 .products-heading').text(text);
  });


  /**************************** Shipping Page JS - H ********************************/
  $( ".shipping-page-template .toggle" ).click(function() {
    $(this).parent("p" ).next().slideToggle( "slow" );
  });


  if ($(window).width() <= 768) {
    //toggle the component with class accordion_body
    $(".accordion_head").click(function() {
      if ($('.accordion_body').is(':visible')) {
        $(".accordion_body").slideUp(300);
        $(".plusminus").html('<i class="fa fa-angle-down"></i>');
      }
      if ($(this).next(".accordion_body").is(':visible')) {
        $(this).next(".accordion_body").slideUp(300);
        $(this).children(".plusminus").html('<i class="fa fa-angle-down"></i>');
      } else {
        $(this).next(".accordion_body").slideDown(300);
        $(this).children(".plusminus").html('<i class="fa fa-angle-up"></i>');
      }
    }); 

    $(".site-nav--has-dropdown").click(function(e) {
      e.preventDefault();
      if ($('.site-nav__dropdown').is(':visible')) {
        $(".site-nav__dropdown").slideUp(300);
        $(".site-nav--has-dropdown").removeClass('rotates');
      }
      if ($(this).children(".site-nav__dropdown").is(':visible')) {
        $(this).children(".site-nav__dropdown").slideUp(300);
        $(this).removeClass('rotates');
      } else {
        $(this).children(".site-nav__dropdown").slideDown(300);
        $(this).addClass('rotates');
      }
    });
    $('.gallery-video').remove();
  }

  //toggle the component with class accordion_body
  $(".accordion-bar").click(function() {
    if($(this).hasClass('reviews_accordion')) return 0;

    if ($('.accordion-body').is(':visible')) {
      $(".accordion-body:not(.reviews_body)").slideUp(300);
      $(".accordion-bar:not(.reviews_accordion) .plusminus").text('+');
    }
    if ($(this).next(".accordion-body:not(.reviews_body)").is(':visible')) {
      $(this).next(".accordion-body:not(.reviews_body)").slideUp(300);
      !$(this).hasClass('reviews_accordion') ? $(this).children(".plusminus").text('+'): ''
    } else {
      $(this).next(".accordion-body:not(.reviews_body)").slideDown(300);
      !$(this).hasClass('reviews_accordion') ? $(this).children(".plusminus").text('-'): ''
    }
  });

  $('.account-item .header-button').click(function(){
    $('.login_regi').show();
    $('.overlay').show();
  })
    
  $('.close_popup').click(function(){
    $('.login_regi').hide();
    $('.overlay').hide();
  })
  $('.overlay').click(function(){
      $('.login_regi').hide();
    $('.overlay').hide();
  })

  /*************************************** Header Menu jQuery for tablet **********************/
  if ($(window).width() <= 1024) {
    $('.site-nav--has-dropdown').each(function(){
      var text = $(this).children('a').html();
      var new_text = text.split(' ');
      if(new_text[14] == "MEN'S" || new_text[14] == "WOMEN'S") {
        $(this).children('a').html(new_text[14]+'<span class="icon icon-arrow-down" aria-hidden="true"></span>')
      }
    })
  }
  $(window).resize(function() {
  if ($(window).width() <= 1300) {
    $('.site-nav--has-dropdown').each(function(){
      var text = $(this).children('a').html();
      var new_text = text.split(' ');
      if(new_text[14] == "MEN'S" || new_text[14] == "WOMEN'S") {
        $(this).children('a').html(new_text[14]+'<span class="icon icon-arrow-down" aria-hidden="true"></span>')
      }
    })
  }
  });
  /**************************** Sticky Header ************************/
  $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 100) {
          //clearHeader, not clearheader - caps H
        $("body .header-bar").addClass("sticky_header");
        $("body").addClass("sticky_header_entered");
      } else {
        $("body .header-bar").removeClass("sticky_header"); 
        $("body").removeClass("sticky_header_entered");
      }
  });
  
  $(document).on('click', 'div#pagination span' , function() {
    $('html, body').animate({
      scrollTop: $(".header1").offset().top 
    }, 500);
  });


  // Product Description Toggle
  $(document).on('click', '.description_toggle_head' , function() {
    if ($(window).width() <= 749) {
      $('.description_toggle:not(.mob-hidden)').slideToggle();
    } else {
      $('.description_toggle:not(.desk-hidden)').slideToggle();
    }
  });
  

  $(document).on('click', '.style_css' , function() {
    var value = $(this).attr('for');
    //alert(value);
    $('#gfqv-select').val(value).trigger('change');
    var image = $(this).attr('data-back');
    // alert(image);
    $(this).parents('.gf-container').find('.product-images-wrapper .product-gallery').find('.owl-item.active .product-gallery__image img').attr('src',image);
    $(this).parents('.gf-container').find('.product-images-wrapper .product-gallery').find('.owl-item.active .product-gallery__image img').attr('data-src',image);
    $(this).parents('.gf-container').find('.product-images-wrapper .product-gallery').find('.owl-item.active .product-gallery__image img').attr('srcset',image);
  });
  
  
  $(document).on('click', '.spf-product__swatch' , function() {    
    $('.spf-product__swatch').removeClass('is-selected');
    var chidl = $(this).attr('data-image');	
    $(this).parents('.spf-product-card').find('.spf-product-card__image-main').attr('src',chidl);	
    $(this).parents('.spf-product-card').find('.spf-product-card__image-main').attr('srcset',chidl);	
    $(this).parents('.spf-product-card').find('.spf-product-card__image-main').attr('data-srcset',chidl);	
    
    $(this).addClass('is-selected');
  });

  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });
  var text1 = $('.timer-cls #days').text();
  console.log(text1);
  if(text1 == '0 Days'){
    $('.timer-cls #days').hide();
  }
  else{
    $('.timer-cls #days').show();
  }
});


/*------- Repair Warranty Code ------*/

const utils = {

  getParamValue(urlString, param) {
    const url = new URL(urlString);
    const paramValue = url.searchParams.get(param); 
    return paramValue;
  },
  
  async addItem(obj) {
     
    const { id, quantity, properties, doNotAddIfAreadyPresent, replaceIfAlreadyPresent } = obj

//     if (doNotAddIfAreadyPresent){
//       const res = await fetch('/cart.js');
//       const { items } = await res.json();
//       console.log('Items: ', items)
//       const itemIsInTheCart = items.find(item => item.id == id);
//       console.log(`Item is already in Cart: ${itemIsInTheCart}`);
//       if (itemIsInTheCart) return;
//     } 

	console.log(properties);

    if (replaceIfAlreadyPresent){
      const res = await fetch('/cart.js');
      const { items } = await res.json();
      console.log('Items: ', items)
      const itemIsInTheCart = items.find(item => item.id == id);
      console.log(`Item is already in Cart: ${Boolean(itemIsInTheCart)}`);
      if (itemIsInTheCart) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
             "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
            id, quantity: 0
          })
        });
        const json = await res.json();
        console.log(json);
      }
    
    }

    console.log('Adding Item');
    const addItemRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id, quantity, properties
      })
    });
	const item = await addItemRes.json();
    return item;
  }
}


const warrantyRepairApp = {
  init() {
    this.container = document.querySelector('.warranty-repair-button-container');
    if (!this.container) return;
    this.buttons = document.querySelectorAll('.warranty-repair-button-container .warranty-repair-button');
    this.setupEventListeners();
  },
  
  setupEventListeners() {
    this.buttons.forEach(button => button.onclick = this.handleButtonClick.bind(this));
  },
  
  handleButtonClick({ target }) {
    const button = target;
    console.log({button})
    const { id, location , title , address, price} = button.dataset;
    sessionStorage.setItem('warrantyId', id);
    sessionStorage.setItem('location', location);
    sessionStorage.setItem('title', title);
    sessionStorage.setItem('address', address);
    sessionStorage.setItem('price', price);
    
   // const url = '/pages/repair-request';
    const url = '/pages/new-form';
    console.log(url);
    window.location.href = url;
  }
  
}


const repairRequestDetailsApp = {
  init() {
    const { getParamValue } = utils;
    this.form = document.querySelector('#repair-request-form');
    if (!this.form) return;
    this.fields = [...this.form.querySelectorAll('[name*="contact"]')];
    this.id = sessionStorage.getItem('warrantyId');
    this.properties = null;
    this.setupEventListeners();
  },
  
  async setupEventListeners() {
    this.fields.forEach(field => field.oninput = this.handleFieldInput.bind(this));
    this.form.onsubmit = await this.handleFormSubmit.bind(this);
  },
      
  handleFieldInput(e) {
    this.properties = this.getProperties();
    sessionStorage.setItem('warrantyProperties', JSON.stringify(this.properties));
  },
  
  async handleFormSubmit(e) {
    
    if (e) e.preventDefault();
    const { addItem } = utils;
    console.log('Prevented Default');

   const properties = JSON.parse(sessionStorage.getItem('warrantyProperties'));
   console.log({properties});
   const data = await addItem({
     id: this.id, 
     quantity: 1, 
     properties: properties, 
     doNotAddIfAreadyPresent: false,
     replaceIfAlreadyPresent: true
   });
    
    console.log('Added Successfuly');
    
     async function addItemOnSuccess(obj) {
     
    const { id, quantity, properties, doNotAddIfAreadyPresent, replaceIfAlreadyPresent } = obj

//     if (doNotAddIfAreadyPresent){
//       const res = await fetch('/cart.js');
//       const { items } = await res.json();
//       console.log('Items: ', items)
//       const itemIsInTheCart = items.find(item => item.id == id);
//       console.log(`Item is already in Cart: ${itemIsInTheCart}`);
//       if (itemIsInTheCart) return;
//     } 

	console.log({test: properties});

    if (replaceIfAlreadyPresent){
      const res = await fetch('/cart.js');
      const { items } = await res.json();
      console.log('Items: ', items)
      const itemIsInTheCart = items.find(item => item.id == id);
      console.log(`Item is already in Cart: ${Boolean(itemIsInTheCart)}`);
      if (itemIsInTheCart) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
             "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
            id, quantity: 0
          })
        });
//         const json = await res.json();
//         console.log(json);
      }
    
    }

    console.log('Adding Item');
    const addItemRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id, quantity, properties
      })
    });
	const item = await addItemRes.json();
  console.log({item})
    return item;
  }
     
   console.log(sessionStorage)
  /*
   async function addWarranty () {
    console.log('Prevented Default');

   const properties = JSON.parse(sessionStorage.getItem('warrantyProperties'));
   
     const id = sessionStorage.getItem('warrantyId');
     console.log(id, properties);
     const data = await addItemOnSuccess({
     id: id, 
     quantity: 1, 
     properties: properties, 
     doNotAddIfAreadyPresent: false,
     replaceIfAlreadyPresent: true
   });
    
    console.log(data, 'Performed Successfuly');
//     await this.form.submit();
  }
  */
async function reloadCartDrawer() {
    try {
        
        console.log('Updated Cart Items:', items);

    } catch (error) {
        console.error('Error reloading cart drawer:', error);
    }
}
    async function addWarranty() {
    try {
        console.log('Prevented Default');

        const properties = JSON.parse(sessionStorage.getItem('warrantyProperties'));
        const id = sessionStorage.getItem('warrantyId');
        console.log(id, properties);

        const data = await addItemOnSuccess({
            id: id,
            quantity: 1,
            properties: properties,
            doNotAddIfAlreadyPresent: false,
            replaceIfAlreadyPresent: true
        });

        console.log(data, 'Performed Successfully');
        if(data){
          reloadMiniCart();
        }
        // Uncomment the following line if you want to submit a form after adding the warranty
        // await this.form.submit();

    } catch (error) {
        console.error('Error in addWarranty:', error);
        // Handle errors here
    }
}

    function reloadMiniCart() {
    jQuery.getJSON('/cart.js', function(cart) {
      var cart_total_item = cart.item_count;
      $('.cart-count').html(cart_total_item);
       var price = cart.total_price;
            // renderProgress(cart);
    } );
  
    
    success();
   
    $('.mini_cart').removeClass('extras');
    $('body').addClass('cart-drawer-open');
     $('.cart-drawer-open button.fixed_button').hide();
    $('.cart-overlays').show();
    $('.mini_cart').css('transform','translate(0px)');
  }

  function success(){
    $.ajax({
      url: "/cart",
      type: 'GET',
      dataType: 'html',
      success: function(response) {
  
        $('.mini_cart').html('');
        var result = $(response).find('.cart_data');
        $('.mini_cart').html(result);
        $('.mini_cart').show();
        $('.cart-overlays').show();
        Shopify.shippingMessageApp.render();
        
        // Extend - Dispatch event to initialize cart offers after mini-cart has been built	
        window.dispatchEvent(new CustomEvent('initCartOffers'));
           $('.cart-orange-on-item').addClass('cart-has-item-css');
      }
    });
    
    if(!$('#af_cart_slider label').hasClass('title_toggle')){
      promocode();
    }
  }
     
     //addWarranty();
     /*
     setTimeout(() => {
        window.location.href = '/cart';    
     }, 1500)
    */
//     await this.form.submit();

    try {
        // Wait for addWarranty to complete
        await addWarranty();
        
        // Select the element by its class
      /*
        var miniCartElement = document.querySelector('.mini_cart.extras');

        // Check if the element is found
        if (miniCartElement) {
            // Add the style to the element
            miniCartElement.style.transform = 'translate(0px)';
        }*/

        console.log('Code executed after addWarranty');
    } catch (error) {
        console.error('Error in executeAfterAddWarranty:', error);
    }
  },

    
  getProperties() {
    const properties = {};
    this.fields.forEach((field) => {
      const temp = field.name.split('[')[1];
      const propertyName = temp.replace(']','');
      if (field.type == 'radio' || field.type == "checkbox"){
        if ( field.checked)
          properties[propertyName] = field.value; 
      } else {
      	properties[propertyName] = field.value;
      }
    });
    return properties;
  }
  
}


//Initialize Function in warranty repair page
warrantyRepairApp.init();
repairRequestDetailsApp.init();


$(function() {
    $('.scroll-tabs li a').on('click', function(e) {
        if (!e) return;
        e.preventDefault();
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.substr(1) +']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top-160
            }, 1000);
            return false;
        }
    });
});
  
function AddReadMore() {
    //This limit you can set after how much characters you want to show Read More.
    var carLmt = 100;
    // Text to show when text is collapsed
    var readMoreTxt = " ... Read More";
    // Text to show when text is expanded
    var readLessTxt = " Read Less";


    //Traverse all selectors with this class and manupulate HTML part to show Read More
    $(".addReadMore").each(function() {
        if ($(this).find(".firstSec").length)
            return;

        var allstr = $(this).text();
        if (allstr.length > carLmt) {
            var firstSet = allstr.substring(0, carLmt);
            var secdHalf = allstr.substring(carLmt, allstr.length);
            var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
        }

    });
    //Read More and Read Less Click Event binding
    $(document).on("click", ".readMore,.readLess", function() {
        $(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
        
    });
}
$(function() {
    //Calling function after Page Load
    AddReadMore();
});

const shippingMessageApp = {
   init() {
    this.country = this.fetchCountry();

    this.shippingMessage = "YOU'VE EARNED FREE SHIPPING!";
    this.model = {

      IN:  '$450',
      US:  '$89', 
      AU:  '$149',
      MT:  '$149',
      ME:  '$149',
      AO:  '$149',
      CO:  '$450',
      ZA:  '$450',
	  BH:  '$450',
  	  KH:  '$450',
      RS:  '$450',
      GH:  '$450',
	  ZW:  '$450',
  	  GR:  '$149',
      HU:  '$149',
      EE:  '$149',
      CR:  '$149',
      CL:  '$149',
      EC:  '$149',
      PE:  '$149',
      KZ:  '$149',
      BA:  '$149',
      BG:  '$149',
      HR:  '$149',
      MK:  '$149',
      PL:  '$149',
      RO:  '$149',
      SK:  '$149',
      SL:  '$149',
      MZ:  '$149',
      NG:  '$149',
      NC:  '$149',
      TR:  '$99 - $149',
      CN:  'block',
      CX:  'block',
      IQ:  'block',
      MM:  'block',
      TM:  'block',
      UZ:  'block',
      DZ:  'block',
      LY:  'block',
      MA:  'block',
      SO:  'block',
      SS:  'block',
      SD:  'block',
      TN:  'block',
      HN:  'block',
      ST:  'block',
      GP:  'block',
      BR:  'block',
      MU:  'block',
      UA:  'block',
      PS:  'block',
      
      
    };

    this.fetchShippingMessage();
    this.render();  
  },

  fetchCountry () {
    if (!ZACB) return;
    const country = ZACB.za_code;
    return country;
  },

  fetchShippingMessage() {

    const { model, country } = this;
    const value = model[country];
  setTimeout(function() {
      if (value == '') {
      this.shippingMessage = "WE DO NOT SHIP TO YOUR COUNTRY";      
     } else if (value == 'block')
      {
      $('body.template-product .product-single .product-page-shiping-as-country').css("display","none");
      $('.product-page-shiping-as-country').css("display","none");
      $('.cart_shipping_bar').css("display","none");
      } else if (value == 'UNDEFINED!')
      {
        $('body.template-product .product-single .product-page-shiping-as-country').css("display","flex");
        $('.product-page-shiping-as-country span.free-ship-price').text("Free Shipping On Orders $149+");
        $('.free-shipping-custom-cartdrawer-text').text("Free Shipping On Orders $149+");
      } else {
      $('body.template-product .product-single .product-page-shiping-as-country').css("display","flex");
      $('.product-page-shiping-as-country span.free-ship-price').text(`${value}+`);
      $('.free-shipping-custom-cartdrawer-text').text(`Free Shipping On Orders ${value}+`);
     }
  }, 1500);

  },



  render() {
    // $('.cart_shipping_bar span').text(this.shippingMessage);
  }
}

shippingMessageApp.init();
Shopify.shippingMessageApp = shippingMessageApp;

$(function() {
    $('#proceedFormWar').on('click', function(e) {
        if (!e) return;
        e.preventDefault();
       $('#firstformre').css('display', 'none')
       $('#secondformre').css('display', 'block')
      $('#formonerepair').css('display', 'none')
       $('#formtworepair').css('display', 'block')
       $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });
});